module.exports = __webpack_public_path__ + "static/couple-sitted-face-left-700w-430944845b6b6dab85fd121b279441a1.png";